"use client";

import { NormalText } from "@/components/text/NormalText";
import { UserNoDates } from "@/types/types";
import { formatDateForOutput } from "@/utils/formatTime/formatDateForOutput";
import { useIsClient } from "@/utils/hooks/useIsClient";
import { getConversionTimeResetDate } from "@/utils/subscriptionLevels/getConversionTimeResetDate";
import { isFreeUser } from "@/utils/subscriptionLevels/isFreeUser";

export function TimeResetText({
  user,
  className,
}: {
  user: UserNoDates | null;
  className?: string;
}) {
  const isClient = useIsClient();

  if (user === null) {
    return null;
  }

  const freeUser = user === null || isFreeUser(user.stripeSubscriptionId);

  const dateResetString =
    (
      user.stripeSubscriptionId !== null &&
      user.stripeSubscriptionEndTimestampString !== null
    ) ?
      getConversionTimeResetDate(
        user.stripeSubscriptionId,
        new Date(user.stripeSubscriptionEndTimestampString)
      ).toString()
    : null;

  return (
    <NormalText elementType="p" className={className}>
      {freeUser ?
        "Conversion time does not refill on the free plan."
      : `Your conversion time will refill on ${
          isClient && dateResetString !== null ?
            formatDateForOutput({
              date: new Date(dateResetString),
              withTime: false,
              withYear: false,
            })
          : ""
        }`
      }
    </NormalText>
  );
}
